export default __webpack_public_path__ + "static/media/our-values-banner-tablet.a5e3cf2f.png";